var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global_layout"},[_c('global-header'),_c('div',[_vm._t("default")],2),_c('global-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }